import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { API_URL } from '../../config';

function ServiceHistory() {
  const [history, setHistory] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [filterStatus, setFilterStatus] = useState('all');

  useEffect(() => {
    fetchHistory();
  }, []);

  const fetchHistory = async () => {
    const response = await axios.get(`${API_URL}/appointments`);
    setHistory(response.data);
  };

  const filteredHistory = history.filter(record => {
    // Apply status filter
    if (filterStatus !== 'all' && record.status !== filterStatus) {
      return false;
    }

    // Apply search filter
    if (searchTerm) {
      const search = searchTerm.toLowerCase();
      return (
        record.client_name?.toLowerCase().includes(search) ||
        record.service_name?.toLowerCase().includes(search) ||
        record.appointment_date?.includes(search) ||
        record.notes?.toLowerCase().includes(search) ||
        record.client_phone?.includes(search)
      );
    }

    return true;
  });

  const formatDate = (dateStr) => {
    const date = new Date(dateStr + 'T00:00:00');
    return date.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' });
  };

  const formatTime = (militaryTime) => {
    const [hours, minutes] = militaryTime.split(':').map(Number);
    const period = hours >= 12 ? 'PM' : 'AM';
    const displayHours = hours > 12 ? hours - 12 : hours === 0 ? 12 : hours;
    return `${displayHours}:${String(minutes).padStart(2, '0')} ${period}`;
  };

  const getStatusBadge = (status) => {
    const badges = {
      pending: { text: 'Pending', class: 'status-pending' },
      scheduled: { text: 'Confirmed', class: 'status-confirmed' },
      completed: { text: 'Completed', class: 'status-completed' },
      cancelled: { text: 'Cancelled', class: 'status-cancelled' }
    };
    return badges[status] || { text: status, class: '' };
  };

  return (
    <div className="service-history">
      <div className="header">
        <h2>Service History</h2>
      </div>

      <div className="history-controls">
        <input
          type="text"
          placeholder="Search by client name, service, phone, date, or notes..."
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          className="search-input"
        />
        <div className="status-filters">
          <button className={filterStatus === 'all' ? 'active' : ''} onClick={() => setFilterStatus('all')}>All</button>
          <button className={filterStatus === 'pending' ? 'active' : ''} onClick={() => setFilterStatus('pending')}>Pending</button>
          <button className={filterStatus === 'scheduled' ? 'active' : ''} onClick={() => setFilterStatus('scheduled')}>Confirmed</button>
          <button className={filterStatus === 'completed' ? 'active' : ''} onClick={() => setFilterStatus('completed')}>Completed</button>
          <button className={filterStatus === 'cancelled' ? 'active' : ''} onClick={() => setFilterStatus('cancelled')}>Cancelled</button>
        </div>
      </div>

      <div className="history-stats">
        <div className="stat-item">
          <span className="stat-label">Total Records:</span>
          <span className="stat-value">{filteredHistory.length}</span>
        </div>
        <div className="stat-item">
          <span className="stat-label">Completed:</span>
          <span className="stat-value">{filteredHistory.filter(r => r.status === 'completed').length}</span>
        </div>
        <div className="stat-item">
          <span className="stat-label">Pending:</span>
          <span className="stat-value">{filteredHistory.filter(r => r.status === 'pending').length}</span>
        </div>
      </div>

      <table>
          <thead>
            <tr>
              <th>Date</th>
              <th>Time</th>
              <th>Client</th>
              <th>Phone</th>
              <th>Service</th>
              <th>Stylist</th>
              <th>Duration</th>
              <th>Price</th>
              <th>Status</th>
              <th>Notes</th>
            </tr>
          </thead>
          <tbody>
            {filteredHistory.length === 0 ? (
              <tr>
                <td colSpan="10" className="no-results">No records found</td>
              </tr>
            ) : (
              filteredHistory.map(record => {
                const statusBadge = getStatusBadge(record.status);

                // Display services - handle both single and multiple services
                let serviceDisplay = record.service_name;
                let durationDisplay = record.service_duration;
                let priceDisplay = record.service_price;

                if (record.services && record.services.length > 0) {
                  if (record.services.length === 1) {
                    serviceDisplay = record.services[0].name;
                  } else {
                    serviceDisplay = record.services.map(s => s.name).join(', ');
                  }
                  durationDisplay = record.total_duration || record.service_duration;
                  priceDisplay = record.total_price || record.service_price;
                }

                return (
                  <tr key={record.id}>
                    <td>{formatDate(record.appointment_date)}</td>
                    <td>{formatTime(record.appointment_time)}</td>
                    <td className="client-name">{record.client_name}</td>
                    <td>{record.client_phone}</td>
                    <td>{serviceDisplay}</td>
                    <td>{record.stylist_name || '-'}</td>
                    <td>{durationDisplay} min</td>
                    <td>${priceDisplay}</td>
                    <td>
                      <span className={`status-badge ${statusBadge.class}`}>
                        {statusBadge.text}
                      </span>
                    </td>
                    <td className="notes-cell">{record.notes || '-'}</td>
                  </tr>
                );
              })
            )}
          </tbody>
        </table>
    </div>
  );
}

export default ServiceHistory;
